import { User } from '@restore/services-lib';
import { months } from 'const/date';
import { ContentState, EditorState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import { DateTime } from 'luxon';
import { getDateTime } from 'utils/dates';

export const dateFormatter = (
  date?: Date | string | DateTime,
  format = 'D',
  placeholder = 'N/A'
) => {
  if (!date) {
    return placeholder;
  }

  const datetime = getDateTime(date);
  if (!datetime) {
    return placeholder;
  }

  return datetime.toFormat(format);
};

export const formatDatePickerDate = (date?: Date | string, placeholder = 'N/A') => {
  if (!date) return placeholder;

  const dateArr = String(date).split('-');
  dateArr.push(dateArr.splice(0, 1)[0]);
  return dateArr.join('/');
};

export const formatDate = (date?: Date, placeholder = 'N/A', includeTime?: boolean) => {
  if (!date) return placeholder;

  const newDate = new Date(date);
  const month = newDate.getMonth();
  const day = newDate.getDate();
  const year = newDate.getFullYear();
  let time = '';

  if (includeTime) {
    time = newDate.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });

    if (time[0] === '0') {
      time = `, ${time.substring(1)}`;
    } else {
      time = `, ${time}`;
    }
  }

  return `${months[month]} ${day}, ${year}${time}`;
};

export const formatMinutes = (minutes?: number | string) => {
  if (minutes === undefined) return;

  if (Number(minutes) > 59) {
    const hours = Math.round((Number(minutes) / 60) * 10) / 10;

    return `${hours} ${hours === 1 ? 'hour' : 'hours'}`;
  }

  return `${minutes} minute(s)`;
};

export const getUsersName = (user?: Pick<User, 'firstName' | 'lastName'> | null) =>
  user ? `${user?.firstName} ${user?.lastName}` : 'N/A';

export const truncateText = (text: string, length = 20) => {
  if (text.length > length) {
    return `${text.slice(0, length)}...`;
  }

  return text;
};

export const convertHTMLStringToPlainString = (richText: string): string => {
  // try catch is placed here to not break the page in case data is not convertable
  try {
    const htmlState = htmlToDraft(richText);
    const richTextContentState = ContentState.createFromBlockArray(htmlState.contentBlocks);
    const richTextEditorState: EditorState = EditorState.createWithContent(richTextContentState);
    return richTextEditorState.getCurrentContent().getPlainText();
  } catch (e) {
    return richText;
  }
};

export const convertHTMLStringToEditorState = (
  richText: string | undefined
): EditorState | undefined => {
  if (!richText) {
    return undefined;
  }

  try {
    //try catch in case json is not parseable
    const htmlState = htmlToDraft(richText);
    const richTextContentState = ContentState.createFromBlockArray(htmlState.contentBlocks);
    return EditorState.createWithContent(richTextContentState);
  } catch (e) {
    return undefined;
  }
};
